import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Disposable } from '../../../base/common/lifecycle.js';
export var ElementSizeObserver = /*#__PURE__*/function (_Disposable) {
  _inherits(ElementSizeObserver, _Disposable);

  var _super = _createSuper(ElementSizeObserver);

  function ElementSizeObserver(referenceDomElement, dimension, changeCallback) {
    var _this;

    _classCallCheck(this, ElementSizeObserver);

    _this = _super.call(this);
    _this.referenceDomElement = referenceDomElement;
    _this.changeCallback = changeCallback;
    _this.width = -1;
    _this.height = -1;
    _this.resizeObserver = null;
    _this.measureReferenceDomElementToken = -1;

    _this.measureReferenceDomElement(false, dimension);

    return _this;
  }

  _createClass(ElementSizeObserver, [{
    key: "dispose",
    value: function dispose() {
      this.stopObserving();

      _get(_getPrototypeOf(ElementSizeObserver.prototype), "dispose", this).call(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.height;
    }
  }, {
    key: "startObserving",
    value: function startObserving() {
      var _this2 = this;

      if (typeof ResizeObserver !== 'undefined') {
        if (!this.resizeObserver && this.referenceDomElement) {
          this.resizeObserver = new ResizeObserver(function (entries) {
            if (entries && entries[0] && entries[0].contentRect) {
              _this2.observe({
                width: entries[0].contentRect.width,
                height: entries[0].contentRect.height
              });
            } else {
              _this2.observe();
            }
          });
          this.resizeObserver.observe(this.referenceDomElement);
        }
      } else {
        if (this.measureReferenceDomElementToken === -1) {
          // setInterval type defaults to NodeJS.Timeout instead of number, so specify it as a number
          this.measureReferenceDomElementToken = setInterval(function () {
            return _this2.observe();
          }, 100);
        }
      }
    }
  }, {
    key: "stopObserving",
    value: function stopObserving() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }

      if (this.measureReferenceDomElementToken !== -1) {
        clearInterval(this.measureReferenceDomElementToken);
        this.measureReferenceDomElementToken = -1;
      }
    }
  }, {
    key: "observe",
    value: function observe(dimension) {
      this.measureReferenceDomElement(true, dimension);
    }
  }, {
    key: "measureReferenceDomElement",
    value: function measureReferenceDomElement(callChangeCallback, dimension) {
      var observedWidth = 0;
      var observedHeight = 0;

      if (dimension) {
        observedWidth = dimension.width;
        observedHeight = dimension.height;
      } else if (this.referenceDomElement) {
        observedWidth = this.referenceDomElement.clientWidth;
        observedHeight = this.referenceDomElement.clientHeight;
      }

      observedWidth = Math.max(5, observedWidth);
      observedHeight = Math.max(5, observedHeight);

      if (this.width !== observedWidth || this.height !== observedHeight) {
        this.width = observedWidth;
        this.height = observedHeight;

        if (callChangeCallback) {
          this.changeCallback();
        }
      }
    }
  }]);

  return ElementSizeObserver;
}(Disposable);